import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CourseProvider } from './contexts/CourseContext';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import FeaturedCourses from './components/FeaturedCourses';
import LearningPaths from './components/LearningPaths';
import About from './components/About';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import PilotProgram from './components/PilotProgram';
import Careers from './components/Careers';
import StudentDashboard from './components/StudentDashboard';
import AuthSuccess from './components/AuthSuccess';
import DashboardView from './views/DashboardView';
import ProtectedRoute from './components/ProtectedRoute';
import ApexIntelligence from './components/ApexIntelligence';

// Home Page Component
const HomePage: React.FC = () => {
  return (
    <>
      <Hero />
      <FeaturedCourses />
      <About />
      <FAQ />
      <Contact />
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <CourseProvider>
        <Router>
          <div className="App">
            <Navbar />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/pilot-program" element={<PilotProgram />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/products/apex-intelligence" element={<ApexIntelligence />} />
              <Route path="/dashboard" element={<StudentDashboard />} />
              <Route 
                path="/dashboard/courses" 
                element={
                  <ProtectedRoute>
                    <DashboardView />
                  </ProtectedRoute>
                } 
              />
              <Route path="/auth/success" element={<AuthSuccess />} />
            </Routes>
            <Footer />
          </div>
        </Router>
      </CourseProvider>
    </AuthProvider>
  );
}

export default App;
